module.exports = __webpack_public_path__ + "static/img/Cine-Pass.5c646f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Cine-Pass.jpg
// module id = In2c
// module chunks = 11